<template>
  <div>
    <Header page="my_page"/>
    <b-container>
      <div class="d-flex justify-content-center mypage mt-34">
        <div class="mypage_content">
          <div class="text-center" style="overflow: hidden;">
            <div class="avatar mypage-avt">
              <img v-if="editMyPage.avatar" :src="editMyPage.avatar" alt class="avt-modal" ref="displayImage"/>
              <img v-else src="@/assets/images/avt-exp.svg" alt class="avt-modal" ref="displayImage"/>
              <div class="input-upload">
                <label for="uploadfile" class="label-upload"></label>
                <input type="file" id="uploadfile" name="uploadfile" accept=".jpg, .png, .bmp, .gif, .jpeg" class="btn-file input-0"  @change="changeImage($event)"/>
              </div>
              <ModalErrorUploadImage @hidePopupImage="hidePopupImage" :avatarError="avatarError"/>
            </div>
          </div>
          <div class="mypage_name d-none d-lg-block">{{truncate(nameAdmin,20,'...')}}</div>
          <div class="mypage_name d-block d-lg-none">{{truncate(nameAdmin,15,'...')}}</div>
          <div class="mypage_form">
            <form action="" class="mw-536">
              <div class="form-group">
                <label for="" class="mypage__label">お名前<span class="required">*</span></label>
                <div class="input-group">
                  <input type="text" name="" class="input-form" placeholder="お名前を入力してください" v-model="editMyPage.name" :class="{error: !$v.editMyPage.name.required && invalid}" @input="$v.editMyPage.name.$touch()" maxlength="50">
                  <small v-if="!$v.editMyPage.name.required && invalid" class="text-input error">{{message.NAME_REQUIRED}}</small>
                </div>
              </div>
              <div class="form-group">
                <label for="" class="mypage__label">電話番号</label>
                <div class="input-group">
                  <input type="text" id="userName" name="userName" class="input-form" placeholder="電話番号を入力してください" :class="{error: !$v.editMyPage.phone.valid && invalid}" v-model="editMyPage.phone" @input="$v.editMyPage.phone.$touch()">
                  <small v-if="!$v.editMyPage.phone.valid && invalid" class="text-input error">{{message.PHONE_FORMAT}}</small>
                </div>
              </div>
              <label for="" class="mypage__label">メールアドレス</label>
              <input type="text" name="" id="" class="input-form" placeholder="メールアドレスを入力してください" v-model="editMyPage.email" disabled>
              <div class="d-none d-lg-block">
                <div class="d-flex justify-content-between mypage__btnGroup">
                  <button class="btn btn-secondary btn-rounder mr-30" @click="goBack">キャンセル</button>
                  <button class="btn btn-primary btn-rounder" @click="editProfile">保存</button>
                </div>
              </div>
              <div class=" d-block d-lg-none">
                <div class="mb-btn admin-vendor-btnGroup mt-30">
                  <button class="btn btn-primary btn-rounder" type="button" @click="editProfile">保存</button>
                  <button class="btn btn-secondary btn-rounder btn-space" type="button" @click="goBack">キャンセル</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import Header from '@/components/share/Header'
import {mapState} from 'vuex'
import {MESSAGE} from '@/utils/errorjapanese'
import { required } from 'vuelidate/lib/validators'
import ModalErrorUploadImage from '@/components/share/ErrorUploadImage'
export default {
  name: 'edit',
  components: {
    Header,
    ModalErrorUploadImage
  },
  validations: {
    editMyPage: {
      name: {
        required
      },
      phone: {
        valid (phone) {
          if (phone) {
            const validate = /^[0-9-.+]{3,20}$/i.test(phone)
            return validate
          }
          return true
        }
      }
    }
  },
  data () {
    return {
      avatarError: '',
      message: MESSAGE,
      invalid: false
    }
  },
  methods: {
    editProfile (e) {
      e.preventDefault()
      this.invalid = this.$v.$invalid
      if (this.invalid) {
        this.$v.$touch()
        return
      }
      const formData = new FormData()
      if (this.editMyPage.avatar !== this.user.avatar) {
        formData.append('avatar', this.editMyPage.avatar)
      }
      if (this.editMyPage.phone) {
        formData.append('phone', this.editMyPage.phone)
      }
      formData.append('email', this.editMyPage.email)
      formData.append('name', this.editMyPage.name)
      formData.append('_method', 'put')
      this.$store.dispatch('allAuth/editProfileAdmin', formData)
    },
    changeImage (event) {
      if (/\.(jpg|jpeg|png|bmp|gif)$/.test(event.target.files[0].name) && event.target.files[0].size <= 5242880) {
        this.editMyPage.avatar = event.target.files[0]
        let reader = new FileReader()
        reader.addEventListener('load', function () {
          this.$refs.displayImage.src = reader.result
        }.bind(this), false)
        reader.readAsDataURL(this.editMyPage.avatar)
      } else {
        event.target.value = ''
        this.avatarError = MESSAGE.AVATAR_FORMAT
        this.$root.$emit('bv::show::modal', 'modalErrorUploadImage', '#modalErrorUploadImage')
      }
    },
    hidePopupImage () {
      this.avatarError = ''
      this.$root.$emit('bv::hide::modal', 'modalErrorUploadImage', '#modalErrorUploadImage')
    },
    goBack () {
      this.$router.push('/admin/me')
    }
  },
  computed: {
    ...mapState({
      user: state => state.allAuth.user,
      nameAdmin: state => state.allAuth.nameAdmin,
      editMyPage: state => state.allAuth.editMyPage
    })
  },
  mounted () {
    this.$store.dispatch('allAuth/getProfile')
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/stylesheet/admin/mypage.scss';
@media screen and (max-width: 991px) {
  form {
    max-width: 90vw;
    margin: 0 auto;
  }
}
.form-group {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/MyPage/Edit.vue